import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../functions";
import Loading from "../layouts/Loading";
import Env from "../env";
import Info from "./cashier/Info";
import GCashMix from "./cashier/GCashMix";
import GCashEmu from "./cashier/GCashEmu";
// import GCashPlus from "./cashier/GCashPlus";
import GCashPlus from "./cashier/GCashPlusNew";
import GrabMix from "./cashier/GrabMix";
import PayMayaMix from "./cashier/PayMayaMix";
import EnterPayerInfo from "./cashier/EnterPayerInfo";
import EnterPayerInfoGCash from "./cashier/EnterPayerInfoGCash";
import EasypaisaMix from "./cashier/EasypaisaMix";
import UpaisaMix from "./cashier/UpaisaMix";
import JazzCashMix from "./cashier/JazzCashMix";
import DanaMix from "./cashier/DanaMix";
import OvoMix from "./cashier/OvoMix";
import GoPayMix from "./cashier/GoPayMix";
import LinkAjaMix from "./cashier/LinkAjaMix";
import SbcqrmMix from "./cashier/SbcqrmMix";
import SbcqrmMixGCash from "./cashier/SbcqrmMixGCash";
import SbcqrmMixMaya from "./cashier/SbcqrmMixMaya";
import SbcqrmMixGrab from "./cashier/SbcqrmMixGrab";
import TxnMixGCash from "./cashier/TxnMixGCash";
import InfoQrCode from "./cashier/InfoQrCode";
import VudyMixGCash from "./cashier/VudyMixGCash";
import GCashStyle from "./cashier/GCashStyle";
import TxnMixGCashV2 from "./cashier/TxnMixGCashV2";

const styles = {
    inputReadOnlyStyle: {
        backgroundColor: "#FFFFFF",
    },
    boxStyle: {
        overflow: "auto",
        marginBottom: "0.5rem",
    },
    displayNone: {
        display: "none",
    },
    displayNormal: {
        marginBottom: "0.2rem",
    },
    timerPosition: {
        position: "absolute",
    },
    rowMarginBottom: {
        marginBottom: "0rem",
    },
    inputEndRadius: {
        borderBottomRightRadius: "0.25rem",
        borderTopRightRadius: "0.25rem",
    },
    cardBodyPadding: {
        padding: "10px",
    },
    logoMb: {
        marginBottom: "0.1rem",
        display: "none",
    },
    qrCode: {
        width: "75%",
    },
    rowMarginBottomQrCode: {
        marginBottom: "0rem",
        textAlign: "center",
        display: "inline-block",
    },
    labelIconMarginLeft: {
        marginLeft: "5px",
    },
};

let runInterval = null;

class CashierEN extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            code: this.props.match.params.pageCode,
            data: null,
            payerName: null,
            timing: "00:00",
            lngName: "en",
            showTimer: false,
            enterPayerName: "",
            needRePayerInfo: false,
        };
    }

    componentDidMount = () => {
        // let lngName = navigator.language;
        $("#main_layout_card").hide();
        this.props.i18n.changeLanguage(this.state.lngName);
        // this.checkPayerName();
        this.checkReferrer();
        // this.ipTest();
    };

    checkReferrer = async () => {
        if (this.state.code != null) {
            let ref = document.referrer;
            if (ref != "") {
                let sendData = {
                    pageCode: this.state.code,
                    referrer: ref,
                };
                let config = await Func.setAxiosConfig(
                    "/cashier/referrer/check",
                    sendData,
                    "POST",
                    true,
                );
                this.setLoading(true);
                Axios(config)
                    .then((res) => {
                        Func.showLog(res);
                        if (res.data.code != "0") {
                            // Func.swalAlert(
                            //     "Error",
                            //     this.props.t(
                            //         "Conversation.Content.YouCannotUseThisPage"
                            //     ),
                            //     "error"
                            // );
                            Func.swalAlertFunction(
                                "Error",
                                this.props.t(
                                    "Conversation.Content.YouCannotUseThisPage",
                                ),
                                "error",
                                () => window.close(),
                                3000,
                            );
                        } else {
                            this.checkPayerName();
                        }
                    })
                    .catch((err) => {
                        Func.showLog(err);
                    })
                    .finally(() => {
                        this.setLoading(false);
                    });
            } else {
                this.checkPayerName();
            }
        }
    };

    reLoadOrderInfo = async () => {
        this.loadOrderInfo();
    };

    loadOrderInfo = async () => {
        if (this.state.code != null) {
            $("#main_layout_card").hide();
            let sendData = {
                pageCode: this.state.code,
            };
            let config = await Func.setAxiosConfig(
                "/cashier",
                sendData,
                "POST",
                true,
            );
            this.setLoading(true);
            Axios(config)
                .then((res) => {
                    Func.showLog(res);
                    if (res.data.code != "0") {
                        if (
                            res.data.message ==
                            "The current channel is fully loaded, please try again later."
                        ) {
                            Func.swalAlert(
                                "Info",
                                this.props.t(
                                    "Conversation.Content.FullyLoaders",
                                ),
                                "info",
                            );
                        } else {
                            Func.swalAlert(
                                "Warning",
                                res.data.message,
                                "warning",
                            );
                        }
                        this.setLoading(false);
                    } else {
                        if (res.data.data.hasOwnProperty("please_wait")) {
                            if (res.data.data.please_wait == "wait") {
                                // console.log("wait");
                                setTimeout(() => {
                                    this.reLoadOrderInfo();
                                }, 1250);
                            } else {
                                Func.swalAlert(
                                    "Warning",
                                    "Please Try Again Later.",
                                    "warning",
                                );
                                this.setLoading(false);
                            }
                        } else {
                            let payerName = null;
                            if (res.data.data.payerName) {
                                payerName = res.data.data.payerName;
                            }
                            if (!res.data.data.module.includes("_dir")) {
                                $("#main_layout_card").show();
                            }
                            if (!res.data.data.module.includes("_emu")) {
                                if (!res.data.data.module.includes("_plus")) {
                                    if (
                                        !res.data.data.module.includes("_mer")
                                    ) {
                                        let showTimer = true;
                                        switch (res.data.data.module) {
                                            case "sbcqrm_mix_gcash":
                                            case "sbcqrm_mix_maya":
                                            case "sbcqrm_mix_grab":
                                            case "txn_mix_gcash":
                                            case "txn_mix_gcash_v2":
                                            case "gcash_style_qr":
                                                showTimer = false;
                                                break;
                                        }
                                        this.setState({
                                            data: res.data.data,
                                            payerName: payerName,
                                            showTimer: showTimer,
                                        });
                                        this.runTiming();
                                    } else {
                                        this.setState({
                                            data: res.data.data,
                                            payerName: payerName,
                                            showTimer: false,
                                        });
                                    }
                                } else {
                                    this.setState({
                                        data: res.data.data,
                                        payerName: payerName,
                                        showTimer: false,
                                    });
                                }
                            } else {
                                this.getEmuDevice(res.data.data, payerName);
                            }
                            this.setLoading(false);
                        }
                    }
                })
                .catch((err) => {
                    Func.showLog(err);
                    this.setLoading(false);
                })
                .finally(() => {
                    // this.setLoading(false);
                });
        }
    };

    getEmuDevice = async (data, payerName) => {
        let sendData = {
            pageCode: this.state.code,
        };
        let config = await Func.setAxiosConfig(
            "/get/emu/device",
            sendData,
            "POST",
            true,
        );
        Axios(config)
            .then((res) => {
                Func.showLog(res);
                if (res.data.code != "0") {
                    if (res.data.code == "11111111") {
                        Func.swalAlert("Info", res.data.message, "info");
                    } else {
                        let moduleAry = data.module.split("_");
                        data.module = moduleAry[0] + "_mix";
                        this.setState({
                            data: data,
                            payerName: payerName,
                            showTimer: true,
                        });
                        this.runTiming();
                    }
                } else {
                    this.setState({
                        data: data,
                        payerName: payerName,
                    });
                }
            })
            .catch((err) => {
                Func.showLog(err);
            });
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    showData = () => {
        if (!this.state.data) {
            return <div></div>;
        }

        let rtn = <div></div>;

        // $("#main_layout_card").show();

        switch (this.state.data.module) {
            case "enter_payer_info":
                rtn = (
                    <EnterPayerInfo
                        data={this.state.data}
                        styles={styles}
                        payerName={this.state.enterPayerName}
                        changePayerName={(e) => this.changePayerName(e)}
                        enterPayerName={() => this.enterPayerName()}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "enter_payer_info_gcash":
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <EnterPayerInfoGCash
                        data={this.state.data}
                        styles={styles}
                        payerName={this.state.enterPayerName}
                        changePayerName={(e) => this.changePayerNameGCash(e)}
                        enterPayerName={() => this.enterPayerName()}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "easypaisa_mix":
                $(".login-box-msg").html(
                    '<img src="/images/easypaisa/easypaisa.png" style="width: 50%" />',
                );
                rtn = (
                    <EasypaisaMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "upaisa_mix":
                $(".login-box-msg").html(
                    '<img src="/images/upaisa/upaisa.jpg" style="width: 50%" />',
                );
                rtn = (
                    <UpaisaMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "jazzcash_mix":
                $(".login-box-msg").html(
                    '<img src="/images/jazzcash/jazzcash.png" style="width: 50%" />',
                );
                rtn = (
                    <JazzCashMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gcash_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/gcash/ic_gcash_logo_white.webp" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("gcashMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <GCashMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gcash_emu":
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <GCashEmu
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                        needRePayerInfo={this.state.needRePayerInfo}
                    />
                );
                break;
            case "grab_mix":
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/grab/grab-logo-white.png" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("grabMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <GrabMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gcash_mer":
                window.location.replace(this.state.data.detail.redirect_url);
                rtn = <div></div>;
                break;
            case "paymaya_mix":
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/paymaya/paymaya.jpeg" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("payMayaMixBackColor");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <PayMayaMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gcash_plus":
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <GCashPlus
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                        needRePayerInfo={this.state.needRePayerInfo}
                    />
                );
                break;
            case "dana_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/dana/logo.webp" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("ovoMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <DanaMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "ovo_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/ovo/e-wallet-ovo-1.webp" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("ovoMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <OvoMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gopay_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/gopay/GoPay-Logo.png" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("ovoMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <GoPayMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "linkaja_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $(".login-box-msg").html(
                    '<img src="/images/linkaja/logo.webp" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("ovoMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <LinkAjaMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "sbcqrm_mix":
                // Remove CSS
                $("html").css("font-size", "");
                $("body").css("-webkit-tap-highlight-color", "");
                $("#root").css("width", "");
                $("#root").css("justify-content", "");
                $(".login-box").css("overflow", "auto");
                $(".login-box").css("margin", "");
                $(".login-box").css("width", "");

                $("#main_layout_card").css("box-shadow", "");
                $("#main_layout_card_body").css("background-color", "");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "");
                $(".login-card-body").css("padding", "");

                $(".social-auth-links").css("margin", "");
                $(".mb-1").css("margin", "");

                // Add CSS
                $("body").css(
                    "font",
                    "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                // $(".login-box-msg").html(
                //     '<img src="/images/sbcqrm-logo.png" style="width: 50%" />'
                // );
                $(".login-box-msg").html(
                    '<img src="/images/QrPh-Logo.jpeg" style="width: 50%" />',
                );
                $("#main_layout_card").addClass("ovoMixBackColor");
                $("#main_layout_card").css("overflow", "auto");
                $("#main_layout_card_body").css("background-color", "unset");

                rtn = (
                    <SbcqrmMix
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "sbcqrm_mix_gcash":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <SbcqrmMixGCash
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "sbcqrm_mix_maya":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");
                $("#root").css(
                    "background-image",
                    "linear-gradient(to bottom, rgb(77, 61, 152) 30%, rgb(109, 195, 143))",
                );
                $("#main_layout_card_body").css(
                    "background-color",
                    "transparent",
                );
                $("#main_layout_card").css("background-color", "transparent");

                rtn = (
                    <SbcqrmMixMaya
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "sbcqrm_mix_grab":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                $("#root").css("background-color", "rgb(1, 172, 80)");
                $("#main_layout_card_body").css(
                    "background-color",
                    "transparent",
                );
                $("#main_layout_card").css("background-color", "transparent");

                rtn = (
                    <SbcqrmMixGrab
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "txn_mix_gcash":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <TxnMixGCash
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "txn_mix_gcash_v2":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <TxnMixGCashV2
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "vudy_mix_gcash":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <VudyMixGCash
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "gcash_style_qr":
                // Remove CSS
                var screenWidth = window.innerWidth;
                var pageFontSize = screenWidth / 7.5;
                if (pageFontSize > 60) {
                    pageFontSize = 60;
                }

                $("html").css("font-size", pageFontSize + "px");

                $("body").css(
                    "font",
                    ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
                );
                $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

                $("#root").css("width", "100%");
                $("#root").css("justify-content", "unset");
                // $("#root").css("background-color", "#fff");

                $(".login-box").css("overflow", "unset");
                $(".login-box").css("margin", "0");
                $(".login-box").css("width", "100%");

                $("#main_layout_card").css("box-shadow", "unset");
                $("#main_layout_card_body").css("background-color", "#e9ecef");

                $(".login-box-msg").html("");
                $(".login-box-msg").css("padding", "0");
                $(".login-card-body").css("padding", "0");

                $(".social-auth-links").css("margin", "0 !important");
                $(".mb-1").css("margin", "0 !important");

                rtn = (
                    <GCashStyle
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "txn_dir_gcash":
            case "vudy_dir_gcash":
            case "maya_dir":
            case "digiluck_dir":
            case "pts_dir":
            case "xwinpay_dir":
            case "shunfapay_dir":
                window.location.replace(this.state.data.detail.redirect_url);
                rtn = <div></div>;
                break;
            case "info_qrcode":
                rtn = (
                    <InfoQrCode
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            case "info":
                rtn = (
                    <Info
                        data={this.state.data}
                        styles={styles}
                        timing={this.state.timing}
                        payerName={this.state.payerName}
                        ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                        FixPayerName={() => this.FixPayerName()}
                        copyData={(e) => this.copyData(e)}
                        lngName={this.state.lngName}
                    />
                );
                break;
            default:
                rtn = <div></div>;
                break;
        }

        return rtn;

        if (this.state.data.module == "enter_payer_info") {
            return (
                <EnterPayerInfo
                    data={this.state.data}
                    styles={styles}
                    payerName={this.state.enterPayerName}
                    changePayerName={(e) => this.changePayerName(e)}
                    enterPayerName={() => this.enterPayerName()}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "enter_payer_info_gcash") {
            let screenWidth = window.innerWidth;
            let pageFontSize = screenWidth / 7.5;
            if (pageFontSize > 60) {
                pageFontSize = 60;
            }

            $("html").css("font-size", pageFontSize + "px");

            $("body").css(
                "font",
                ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
            );
            $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

            $("#root").css("width", "100%");
            $("#root").css("justify-content", "unset");
            // $("#root").css("background-color", "#fff");

            $(".login-box").css("overflow", "unset");
            $(".login-box").css("margin", "0");
            $(".login-box").css("width", "100%");

            $("#main_layout_card").css("box-shadow", "unset");
            $("#main_layout_card_body").css("background-color", "#e9ecef");

            $(".login-box-msg").html("");
            $(".login-box-msg").css("padding", "0");
            $(".login-card-body").css("padding", "0");

            $(".social-auth-links").css("margin", "0 !important");
            $(".mb-1").css("margin", "0 !important");

            return (
                <EnterPayerInfoGCash
                    data={this.state.data}
                    styles={styles}
                    payerName={this.state.enterPayerName}
                    changePayerName={(e) => this.changePayerNameGCash(e)}
                    enterPayerName={() => this.enterPayerName()}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "info") {
            return (
                <Info
                    data={this.state.data}
                    styles={styles}
                    timing={this.state.timing}
                    payerName={this.state.payerName}
                    ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                    FixPayerName={() => this.FixPayerName()}
                    copyData={(e) => this.copyData(e)}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "gcash_mix") {
            // Remove CSS
            $("html").css("font-size", "");
            $("body").css("-webkit-tap-highlight-color", "");
            $("#root").css("width", "");
            $("#root").css("justify-content", "");
            $(".login-box").css("overflow", "auto");
            $(".login-box").css("margin", "");
            $(".login-box").css("width", "");

            $("#main_layout_card").css("box-shadow", "");
            $("#main_layout_card_body").css("background-color", "");

            $(".login-box-msg").html("");
            $(".login-box-msg").css("padding", "");
            $(".login-card-body").css("padding", "");

            $(".social-auth-links").css("margin", "");
            $(".mb-1").css("margin", "");

            // Add CSS
            $("body").css(
                "font",
                "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
            );
            $(".login-box-msg").html(
                '<img src="/images/gcash/ic_gcash_logo_white.webp" style="width: 50%" />',
            );
            $("#main_layout_card").addClass("gcashMixBackColor");
            $("#main_layout_card").css("overflow", "auto");
            $("#main_layout_card_body").css("background-color", "unset");

            return (
                <GCashMix
                    data={this.state.data}
                    styles={styles}
                    timing={this.state.timing}
                    payerName={this.state.payerName}
                    ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                    FixPayerName={() => this.FixPayerName()}
                    copyData={(e) => this.copyData(e)}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "gcash_emu") {
            let screenWidth = window.innerWidth;
            let pageFontSize = screenWidth / 7.5;
            if (pageFontSize > 60) {
                pageFontSize = 60;
            }

            $("html").css("font-size", pageFontSize + "px");

            $("body").css(
                "font",
                ".32rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
            );
            $("body").css("-webkit-tap-highlight-color", "rgba(0,0,0,0)");

            $("#root").css("width", "100%");
            $("#root").css("justify-content", "unset");
            // $("#root").css("background-color", "#fff");

            $(".login-box").css("overflow", "unset");
            $(".login-box").css("margin", "0");
            $(".login-box").css("width", "100%");

            $("#main_layout_card").css("box-shadow", "unset");
            $("#main_layout_card_body").css("background-color", "#e9ecef");

            $(".login-box-msg").html("");
            $(".login-box-msg").css("padding", "0");
            $(".login-card-body").css("padding", "0");

            $(".social-auth-links").css("margin", "0 !important");
            $(".mb-1").css("margin", "0 !important");

            return (
                <GCashEmu
                    data={this.state.data}
                    styles={styles}
                    timing={this.state.timing}
                    payerName={this.state.payerName}
                    ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                    FixPayerName={() => this.FixPayerName()}
                    copyData={(e) => this.copyData(e)}
                    lngName={this.state.lngName}
                    needRePayerInfo={this.state.needRePayerInfo}
                />
            );
        } else if (this.state.data.module == "grab_mix") {
            $("body").css(
                "font",
                "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
            );
            $(".login-box-msg").html(
                '<img src="/images/grab/grab-logo-white.png" style="width: 50%" />',
            );
            $("#main_layout_card").addClass("grabMixBackColor");
            $("#main_layout_card").css("overflow", "auto");
            $("#main_layout_card_body").css("background-color", "unset");

            return (
                <GrabMix
                    data={this.state.data}
                    styles={styles}
                    timing={this.state.timing}
                    payerName={this.state.payerName}
                    ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                    FixPayerName={() => this.FixPayerName()}
                    copyData={(e) => this.copyData(e)}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "gcash_mer") {
            window.location.replace(this.state.data.detail.redirect_url);
            return <div></div>;
        } else if (this.state.data.module == "paymaya_mix") {
            $("body").css(
                "font",
                "1rem/1.4 Karla,Poppins,Helvetica,Arial,sans-serif",
            );
            $(".login-box-msg").html(
                '<img src="/images/paymaya/paymaya.jpeg" style="width: 50%" />',
            );
            $("#main_layout_card").addClass("payMayaMixBackColor");
            $("#main_layout_card_body").css("background-color", "unset");

            return (
                <PayMayaMix
                    data={this.state.data}
                    styles={styles}
                    timing={this.state.timing}
                    payerName={this.state.payerName}
                    ChangeFixPayerName={(e) => this.ChangeFixPayerName(e)}
                    FixPayerName={() => this.FixPayerName()}
                    copyData={(e) => this.copyData(e)}
                    lngName={this.state.lngName}
                />
            );
        } else if (this.state.data.module == "") {
            return <div></div>;
        }
    };

    runTiming = () => {
        if (this.state.data.timing > 0) {
            let time = this.state.data.timing;
            let duration = moment.duration(time * 1000, "milliseconds");
            let interval = 1000;
            let setTiming = (timing, duration) => {
                if (timing === "00:00") {
                    Func.swalAlert(
                        "Info",
                        "The transaction time has passed.",
                        "info",
                    );
                    clearInterval(runInterval);
                    this.setState({
                        timing: timing,
                        data: null,
                    });
                } else {
                    this.setState({
                        timing: timing,
                    });
                    if (duration % 20000 == 0) {
                        this.checkOrderStatus();
                    }
                }
            };
            runInterval = setInterval(() => {
                duration = moment.duration(
                    duration.asMilliseconds() - interval,
                    "milliseconds",
                );
                // Func.showLog(duration);
                let timeSet = moment(duration.asMilliseconds());
                let timing = timeSet.format("mm:ss");
                // Func.showLog(timing);
                setTiming(timing, duration);
            }, interval);
        } else {
            this.setState({
                timing: "00:00",
                data: null,
            });
            Func.swalAlert(
                "Info",
                "The transaction time has passed.",
                "info",
                30000,
            );
        }
    };

    copyData = (e) => {
        e.preventDefault();

        let target = e.target;

        target.select();

        document.execCommand("Copy");

        Func.toastrAlert("info", "Already Copy Data To Clipboard", 4);
    };

    ChangeFixPayerName = (e) => {
        this.setState({ payerName: e.target.value });
    };

    FixPayerName = async () => {
        let sendDatas = {
            providerOrderNo: this.state.data.cashierNo,
            systemOrderNo: this.state.data.orderNo,
            pageCode: this.state.code,
            payerName: this.state.payerName,
        };

        let axConfig = await Func.setAxiosConfig(
            "/fix/payername",
            sendDatas,
            "POST",
            true,
        );

        try {
            this.setLoading(true);
            let res = await Axios(axConfig);
            Func.showLog(res);

            switch (res.data.code) {
                case "0":
                    Func.swalAlert(
                        "Success",
                        "Modification is successful, please make payment.",
                        "success",
                    ); // 成功
                    break;
                case "05200001":
                    Func.swalAlert(
                        "Warning",
                        "The order status has been changed and cannot be modified.",
                        "warning",
                    ); // 無法修改(訂單狀態)
                    break;
                case "05200002":
                    Func.swalAlert(
                        "Warning",
                        "You have not changed the information.",
                        "warning",
                    ); // 未變更
                    break;
                case "05200003":
                    Func.swalAlert(
                        "Warning",
                        "You have changed your information.",
                        "warning",
                    ); // 無法修改(已變更過)
                    break;
                case "05200004":
                    Func.swalAlert(
                        "Alert",
                        "An accident occurred and cannot be modified.",
                        "warning",
                    ); // 無法修改(發生錯誤)
                    break;
            }
        } catch (err) {
            Func.swalAlert(
                "Error",
                "An accident occurred and cannot be modified.",
                "error",
            );
            Func.showLog(err);
        } finally {
            this.setLoading(false);
        }
    };

    checkPayerName = async () => {
        if (this.state.code != null) {
            let sendData = {
                pageCode: this.state.code,
            };
            let config = await Func.setAxiosConfig(
                "/check/payer/info",
                sendData,
                "POST",
                true,
            );
            try {
                this.setLoading(true);
                let res = await Axios(config);
                Func.showLog(res);
                if (res.data.data.needRePayerInfo) {
                    this.setLoading(false);
                    $("#main_layout_card").show();
                    this.setState({
                        data: res.data.data,
                        needRePayerInfo: res.data.data.needRePayerInfo,
                    });
                } else {
                    this.setLoading(false);
                    if (this.props.match.params.hasOwnProperty("uniqueNo")) {
                        let keepChkOs = await this.keepCheckOrderStatus();
                        let keepChkOsCnt = 0;
                        if (keepChkOs) {
                            this.keepCheckOrderTips(
                                "info",
                                "TransactionConfirming",
                                this.props.match.params.uniqueNo,
                            );
                        } else {
                            this.keepCheckOrderTips(
                                "success",
                                "TransactionSuccess",
                                this.props.match.params.uniqueNo,
                            );
                        }
                        while (keepChkOs) {
                            if (keepChkOsCnt >= 14) {
                                keepChkOs = false;
                                this.keepCheckOrderTips(
                                    "warning",
                                    "TransactionMayPending",
                                    this.props.match.params.uniqueNo,
                                );
                            } else {
                                await Func.sleep(20000);
                                keepChkOs = await this.keepCheckOrderStatus();
                                if (!keepChkOs) {
                                    this.keepCheckOrderTips(
                                        "success",
                                        "TransactionSuccess",
                                        this.props.match.params.uniqueNo,
                                    );
                                } else {
                                    keepChkOsCnt++;
                                }
                            }
                        }
                    } else {
                        this.loadOrderInfo();
                    }
                }
            } catch (err) {
                this.setLoading(false);
                Func.showLog(err);
            }
        }
    };

    enterPayerName = async () => {
        if (this.state.code != null) {
            let sendData = {
                pageCode: this.state.code,
                payerInfoData: this.state.enterPayerName,
            };
            let config = await Func.setAxiosConfig(
                "/enter/payer/info",
                sendData,
                "POST",
                true,
            );
            this.setLoading(true);
            Axios(config)
                .then((res) => {
                    this.setLoading(false);
                    Func.showLog(res);
                    if (res.data.code != 0) {
                        Func.swalAlert("Warning", res.data.message, "warning");
                    } else {
                        this.loadOrderInfo();
                    }
                })
                .catch((err) => {
                    Func.showLog(err);
                });
        }
    };

    changePayerName = (e) => {
        this.setState({ enterPayerName: e.target.value });
    };

    changePayerNameGCash = (e) => {
        if (this.state.enterPayerName == "" && e.target.value == "0") {
        } else {
            this.setState({ enterPayerName: e.target.value });
        }
    };

    checkOrderStatus = async () => {
        if (this.state.code != null) {
            let sendData = {
                pageCode: this.state.code,
            };
            let config = await Func.setAxiosConfig(
                "/check/order/status",
                sendData,
                "POST",
                true,
            );
            // this.setLoading(true);
            Axios(config)
                .then((res) => {
                    // this.setLoading(false);
                    Func.showLog(res);
                    if (res.data.code == 0 && res.data.data.status == 2) {
                        this.setState({ timing: "00:00", data: null });
                        Func.swalAlert(
                            "Info",
                            this.props.t("Cashier.TransactionSuccess"),
                            "info",
                            30000,
                        );
                        clearInterval(runInterval);
                    }
                })
                .catch((err) => {
                    Func.showLog(err);
                });
        }
    };

    keepCheckOrderStatus = async () => {
        let keepChk = true;
        if (this.state.code != null) {
            let sendData = {
                pageCode: this.state.code,
            };
            let config = await Func.setAxiosConfig(
                "/check/order/status",
                sendData,
                "POST",
                true,
            );
            try {
                let res = await Axios(config);
                Func.showLog(res);
                if (res.data.code == 0 && res.data.data.status == 2) {
                    keepChk = false;
                }
            } catch (e) {}
        }

        return keepChk;
    };

    keepCheckOrderTips = (icon, message, uniqueNo) => {
        Func.swalAlert(
            "Information",
            this.props.t("Cashier." + message) + "<br />" + uniqueNo,
            icon,
            300000,
        );
    };

    ipTest = async () => {
        let config = await Func.setAxiosConfig(
            // "https://gwy-mgt.aksopay.com/api/ip",
            // "https://proxy.harugame.com/test/api/ip",
            "https://cashier-cross.aksopay.com/owner/api/ip",
            {},
            "POST",
            true,
        );
        // this.setLoading(true);

        // let sPath = window.location.pathname;
        // let sSearch = window.location.search;

        // window.history.replaceState(null, "", "https://www.google.com/");

        // Axios.defaults.headers.common["origin"] = null;

        // Axios.defaults.withCredentials = true;

        Axios(config)
            .then((res) => {})
            .catch((err) => {
                Func.showLog(err);
            });

        // window.history.replaceState(null, "", sPath + sSearch);
    };

    render() {
        $("body").addClass("login-page");
        $("body").addClass("hold-transition");
        $("body").css("height", "100vh");
        $("#root").addClass("login-page");
        $("#root").css("width", "100%");

        return (
            <div className="login-box" style={styles.boxStyle}>
                <div className="login-logo" style={styles.logoMb}>
                    <a href="#">
                        <b>{Env.firstName}</b>
                        {Env.lastName}
                    </a>
                </div>
                <div id="main_layout_card" className="card">
                    <div
                        id="main_layout_card_body"
                        className="card-body login-card-body"
                        style={styles.cardBodyPadding}
                    >
                        {this.state.showTimer ? (
                            <span
                                className="badge badge-danger left text-md"
                                style={styles.timerPosition}
                            >
                                {this.state.timing}
                            </span>
                        ) : (
                            ""
                        )}
                        <p className="login-box-msg">Payment Information</p>
                        {this.showData()}

                        <div className="social-auth-links text-center mb-3"></div>

                        <p className="mb-1"></p>
                        <p className="mb-0"></p>
                    </div>
                </div>
                {this.state.isLoading ? <Loading /> : ""}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(CashierEN), CashierEN);

// function EnterPayerInfo(props) {
//     const { t, i18n } = useTranslation();

//     // i18n.changeLanguage(this.props.lngName);
//     let showPayerNameStyle = styles.displayNormal;

//     return (
//         <div>
//             <div className="form-group row" style={showPayerNameStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {t("Cashier." + props.data.payerInfoType)}
//                 </label>
//                 <div
//                     className="col-sm-12 input-group input-group-sm"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         id="payerName"
//                         name="payerName"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.payerName}
//                         onChange={(e) => props.changePayerName(e)}
//                     />
//                     {/* <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div> */}
//                     <div className="input-group-append">
//                         <button
//                             type="button"
//                             className="btn btn-sm btn-info btn-flat"
//                             style={styles.inputEndRadius}
//                             onClick={() => props.enterPayerName()}
//                         >
//                             {t("Cashier.Submit")}
//                         </button>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {t("Cashier." + props.data.payerInfoDesc)}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// function Info(props) {
//     const { t, i18n } = useTranslation();

//     let showPostScriptStyle = styles.displayNormal;
//     if (!props.data.detail.postscript) {
//         showPostScriptStyle = styles.displayNone;
//     }
//     let showPayerNameStyle = styles.displayNormal;
//     if (!props.data.payerName) {
//         showPayerNameStyle = styles.displayNone;
//     }

//     let inputEndRadius = styles.inputEndRadius;

//     return (
//         <div>
//             {/* <div className="form-group row">
//                 <label>{t("Cashier.TradeableTime")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.timing}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-stopwatch"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             <div className="form-group row" style={showPayerNameStyle}>
//                 <label className="col-sm-4 col-form-label text-sm">
//                     Payer Name
//                 </label>
//                 <div className="col-sm-8" style={styles.rowMarginBottom}>
//                     <input
//                         id="payerName"
//                         name="payerName"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.payerName}
//                         // onChange={(e) => props.ChangeFixPayerName(e)}
//                         readOnly
//                     />
//                     {/* <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div> */}
//                     {/* <div className="input-group-append">
//                         <button
//                             type="button"
//                             className="btn btn-sm btn-info btn-flat"
//                             onClick={() => props.FixPayerName()}
//                         >
//                             {t("Cashier.FixPayerName")}
//                         </button>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {t("Cashier.PayerContent")}
//                     </div> */}
//                 </div>
//             </div>
//             <div className="form-group row" style={showPostScriptStyle}>
//                 <label className="col-sm-2 col-form-label text-sm">
//                     Postscript
//                 </label>
//                 <div
//                     className="input-group col-sm-10"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="postscript"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.postscript}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas fa-file-alt"></span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {
//                             'Please do not fill in sensitive words such as "postscript" and "recharge" in the postscript of the bank.'
//                         }
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-2 col-form-label text-sm">
//                     Amount
//                 </label>
//                 <div
//                     className="input-group col-sm-10"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="amount"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.amount}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas fa-money-bill-wave"></span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {
//                             "Please make sure to pay according to the amount indicated above."
//                         }
//                         <br />
//                         {
//                             "Modifying the amount will cause the account to be unable to be credited or transferred to other accounts. The system will not bear the responsibility. Please be responsible for the consequences!"
//                         }
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-4 col-form-label text-sm">
//                     Bank Name
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="bank_name"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.bank}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-university"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-4 col-form-label text-sm">
//                     Bank Branch
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="bank_branch"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.bank_branch}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-university"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-5 col-form-label text-sm">
//                     Card Number
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_no"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.card_no}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas fa-credit-card"></span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {
//                             "Single use only, saving account information and other information for private transfers and repeated payments are invalid."
//                         }
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     Card Name
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_owner"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.card_owner}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* <div className="form-group">
//                 <label>{t("Cashier.OrderNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="order_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.orderNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fab fa-wpforms"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             {/* <div className="form-group">
//                 <label>{t("Cashier.CashierNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.cashierNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-cash-register"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//     );
// }

// function GCashMix(props) {
//     const { t, i18n } = useTranslation();

//     let showPostScriptStyle = styles.displayNormal;
//     if (!props.data.detail.postscript) {
//         showPostScriptStyle = styles.displayNone;
//     }
//     let showPayerNameStyle = styles.displayNormal;
//     if (!props.data.payerName) {
//         showPayerNameStyle = styles.displayNone;
//     }

//     let inputEndRadius = styles.inputEndRadius;

//     return (
//         <div>
//             {/* <div className="form-group row">
//                 <label>{t("Cashier.TradeableTime")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.timing}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-stopwatch"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             <div className="form-group row" style={showPayerNameStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.PayerPhoneNumber")} */}
//                     Payer PhoneNumber
//                 </label>
//                 <div className="col-sm-12" style={styles.rowMarginBottom}>
//                     <input
//                         id="payerName"
//                         name="payerName"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.payerName}
//                         // onChange={(e) => props.ChangeFixPayerName(e)}
//                         readOnly
//                     />
//                     {/* <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div> */}
//                     {/* <div className="input-group-append">
//                         <button
//                             type="button"
//                             className="btn btn-sm btn-info btn-flat"
//                             onClick={() => props.FixPayerName()}
//                         >
//                             {t("Cashier.FixPayerName")}
//                         </button>
//                     </div> */}
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.GCashPayerContent")} */}
//                         Please explicitly confirm that the mobile number you
//                         provide is your GCash account.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={showPostScriptStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.Postscript")} */}
//                     Postscript
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="postscript"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.postscript}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas fa-file-alt"></span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.PostscriptContent")} */}
//                         Please do not fill in sensitive words such as "upper
//                         points" and "recharge" in the bank's postscript.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.Amount")} */}
//                     Amount
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="amount"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.amount}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text "
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.AmountContent1")} */}
//                         Please be sure to pay according to the amount indicated
//                         above.
//                         <br />
//                         {/* {t("Cashier.AmountContent2")} */}
//                         Modifying the amount will cause the account to be unable
//                         to be credited or transferred to other accounts, the
//                         system will not bear the responsibility, please be
//                         responsible for the consequences!
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.ReceiveGCashAccount")} */}
//                     Receiving GCash Account
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_no"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.phone_number}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text text-xs"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.CardNumberContent")} */}
//                         It is for single use only, and it is invalid to keep
//                         account information and other information for private
//                         transfers and repeated payments.
//                     </div>
//                 </div>
//             </div>
//             {props.data.detail.qrcode && props.data.detail.qrcode != "" ? (
//                 <div className="form-group row" style={styles.rowMarginBottom}>
//                     <label className="col-sm-12 col-form-label text-sm">
//                         {/* {t("Cashier.QrCode")} */}
//                         Payment QR code
//                     </label>
//                     <div
//                         className="input-group col-sm-12"
//                         style={styles.rowMarginBottomQrCode}
//                     >
//                         <img
//                             src={props.data.detail.qrcode}
//                             style={styles.qrCode}
//                         />
//                     </div>
//                 </div>
//             ) : (
//                 ""
//             )}

//             {/* <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {t("Cashier.GCashOwner")}
//                     Receiving Name
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_owner"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.card_owner}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             {/* <div className="form-group">
//                 <label>{t("Cashier.OrderNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="order_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.orderNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fab fa-wpforms"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             {/* <div className="form-group">
//                 <label>{t("Cashier.CashierNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.cashierNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-cash-register"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//     );
// }

// function GrabMix(props) {
//     const { t, i18n } = useTranslation();

//     let showPostScriptStyle = styles.displayNormal;
//     if (!props.data.detail.postscript) {
//         showPostScriptStyle = styles.displayNone;
//     }
//     let showPayerNameStyle = styles.displayNormal;
//     if (!props.data.payerName) {
//         showPayerNameStyle = styles.displayNone;
//     }

//     let inputEndRadius = styles.inputEndRadius;

//     return (
//         <div>
//             {/* <div className="form-group row">
//                 <label>{t("Cashier.TradeableTime")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.timing}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-stopwatch"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             <div className="form-group row" style={showPayerNameStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.PayerName")} */}
//                     Payer Name
//                 </label>
//                 <div className="col-sm-12" style={styles.rowMarginBottom}>
//                     <input
//                         id="payerName"
//                         name="payerName"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.payerName}
//                         // onChange={(e) => props.ChangeFixPayerName(e)}
//                         readOnly
//                     />
//                     {/* <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div> */}
//                     {/* <div className="input-group-append">
//                         <button
//                             type="button"
//                             className="btn btn-sm btn-info btn-flat"
//                             onClick={() => props.FixPayerName()}
//                         >
//                             {t("Cashier.FixPayerName")}
//                         </button>
//                     </div> */}
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.GrabPayerContent")} */}
//                         Please explicitly confirm that the name you provide is
//                         the same as the setting on the GrabPay App.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={showPostScriptStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.Postscript")} */}
//                     Postscript
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="postscript"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.postscript}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.PostscriptContent")} */}
//                         Please do not fill in sensitive words such as "upper
//                         points" and "recharge" in the bank's postscript.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.Amount")} */}
//                     Amount
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="amount"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.amount}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text "
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.AmountContent1")} */}
//                         Please be sure to pay according to the amount indicated
//                         above.
//                         <br />
//                         {/* {t("Cashier.AmountContent2")} */}
//                         Modifying the amount will cause the account to be unable
//                         to be credited or transferred to other accounts, the
//                         system will not bear the responsibility, please be
//                         responsible for the consequences!
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {/* {t("Cashier.ReceiveGrabAccount")} */}
//                     Receiving Grab Account
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_no"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.phone_number}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text text-xs"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         {/* {t("Cashier.CardNumberContent")} */}
//                         It is for single use only, and it is invalid to keep
//                         account information and other information for private
//                         transfers and repeated payments.
//                     </div>
//                 </div>
//             </div>
//             {props.data.detail.qrcode && props.data.detail.qrcode != "" ? (
//                 <div className="form-group row" style={styles.rowMarginBottom}>
//                     <label className="col-sm-12 col-form-label text-sm">
//                         {/* {t("Cashier.QrCode")} */}
//                         Payment QR code
//                     </label>
//                     <div
//                         className="input-group col-sm-12"
//                         style={styles.rowMarginBottomQrCode}
//                     >
//                         <img
//                             src={props.data.detail.qrcode}
//                             style={styles.qrCode}
//                         />
//                     </div>
//                 </div>
//             ) : (
//                 ""
//             )}

//             {/* <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     {t("Cashier.GCashOwner")}
//                     Receiving Name
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_owner"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.card_owner}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-user"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             {/* <div className="form-group">
//                 <label>{t("Cashier.OrderNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="order_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.orderNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fab fa-wpforms"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//             {/* <div className="form-group">
//                 <label>{t("Cashier.CashierNo")}</label>
//                 <div className="input-group mb-3">
//                     <input
//                         name="cashier_no"
//                         className="form-control"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.cashierNo}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div className="input-group-text">
//                             <span className="fas fa-cash-register"></span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//     );
// }

// function GCashEmu(props) {
//     const { t, i18n } = useTranslation();

//     let showPostScriptStyle = styles.displayNormal;
//     if (!props.data.detail.postscript) {
//         showPostScriptStyle = styles.displayNone;
//     }
//     let showPayerNameStyle = styles.displayNormal;
//     if (!props.data.payerName) {
//         showPayerNameStyle = styles.displayNone;
//     }

//     let inputEndRadius = styles.inputEndRadius;

//     return (
//         <div>
//             <div className="form-group row" style={showPayerNameStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     Payer PhoneNumber
//                 </label>
//                 <div className="col-sm-12" style={styles.rowMarginBottom}>
//                     <input
//                         id="payerName"
//                         name="payerName"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.payerName}
//                         readOnly
//                     />
//                     <div className="input-group text-danger text-xs">
//                         Please explicitly confirm that the mobile number you
//                         provide is your GCash account.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={showPostScriptStyle}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     Postscript
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="postscript"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.postscript}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas fa-file-alt"></span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         Please do not fill in sensitive words such as "upper
//                         points" and "recharge" in the bank's postscript.
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     Amount
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="amount"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.amount}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text "
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         Please be sure to pay according to the amount indicated
//                         above.
//                         <br />
//                         Modifying the amount will cause the account to be unable
//                         to be credited or transferred to other accounts, the
//                         system will not bear the responsibility, please be
//                         responsible for the consequences!
//                     </div>
//                 </div>
//             </div>
//             <div className="form-group row" style={styles.rowMarginBottom}>
//                 <label className="col-sm-12 col-form-label text-sm">
//                     Receiving GCash Account
//                 </label>
//                 <div
//                     className="input-group col-sm-12"
//                     style={styles.rowMarginBottom}
//                 >
//                     <input
//                         name="card_no"
//                         className="form-control form-control-sm"
//                         style={styles.inputReadOnlyStyle}
//                         value={props.data.detail.phone_number}
//                         onClick={(e) => props.copyData(e)}
//                         readOnly
//                     />
//                     <div className="input-group-append">
//                         <div
//                             className="input-group-text text-xs"
//                             style={inputEndRadius}
//                         >
//                             <span className="fas text-xs">Copy</span>
//                         </div>
//                     </div>
//                     <div className="input-group text-danger text-xs">
//                         It is for single use only, and it is invalid to keep
//                         account information and other information for private
//                         transfers and repeated payments.
//                     </div>
//                 </div>
//             </div>
//             {props.data.detail.qrcode && props.data.detail.qrcode != "" ? (
//                 <div className="form-group row" style={styles.rowMarginBottom}>
//                     <label className="col-sm-12 col-form-label text-sm">
//                         Payment QR code
//                     </label>
//                     <div
//                         className="input-group col-sm-12"
//                         style={styles.rowMarginBottomQrCode}
//                     >
//                         <img
//                             src={props.data.detail.qrcode}
//                             style={styles.qrCode}
//                         />
//                     </div>
//                 </div>
//             ) : (
//                 ""
//             )}
//         </div>
//     );
// }
